import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";

import "./plugins/vue-cookies";
import vuetify from "./plugins/vuetify";

import Notifications from "vue-notification";
import VueClipboard from "vue-clipboard2";
import { setInteractionMode } from "vee-validate";

Vue.use(Notifications);
setInteractionMode("eager");

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
